import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const { processSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const user = await processSession(sessionId);
          // Navigate to dashboard with user data
          navigate('/dashboard', { state: { user }, replace: true });
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/', { replace: true });
        }
      } else {
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, processSession, navigate]);

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#BFA05F] animate-spin mx-auto" />
        <p className="mt-4 text-[#635E54]">A autenticar...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
